import { useLocation, useNavigate } from "react-router-dom";
import { getAgeVerificationSourceFromSearch, getAgeVerificationTokenFromSearch } from "@/common/utils/ageVerification";
import { loadAgeVerificationToken, setAgeVerificationToken } from "@/common/utils/storage";
import { useEffect, useState } from "react";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

export const useAgeVerificationToken = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const setAvPromptSource = useAnalyticsStore((state) => state.setAvPromptSource);

  const [token, setToken] = useState<string | null | undefined>();

  useEffect(() => {
    const tokenFromSearch = getAgeVerificationTokenFromSearch(search);

    if (tokenFromSearch) {
      setAvPromptSource(getAgeVerificationSourceFromSearch(search));
      setAgeVerificationToken(tokenFromSearch);
      setToken(tokenFromSearch);
      navigate(pathname, { replace: true });
      return;
    }

    setToken(loadAgeVerificationToken());
  }, [pathname, search, setAvPromptSource]);

  return {
    token,
  };
};
